export const CLEAR_ADD_CHANGE_ERROR = 'CLEAR_ADD_CHANGE_ERROR';
export const ADD_CHANGE_ERROR = 'ADD_CHANGE_ERROR';

export const clearAddChangeError = () => ({
  type: CLEAR_ADD_CHANGE_ERROR,
});

export const addChangeError = error => {
  return {
    type: ADD_CHANGE_ERROR,
    payload: error,
  };
};
